import { render, staticRenderFns } from "./insuranceTypesList.vue?vue&type=template&id=1fd96ba4&"
import script from "./insuranceTypesList.vue?vue&type=script&lang=js&"
export * from "./insuranceTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports